<template>
    <div>
        <b-card v-if="crear" align="left" title="Nueva Gestión" border-variant="light">
            <b-card-text>
                <b-form @submit.prevent="guardar" @reset="cancelar">
                    <b-form-group id="campo1" label-for="nombre" label="Gestión:" :invalid-feedback="gestionNoValido" label-size="lg">
                        <b-form-input id="nombre" v-model="gestion" :state="validarGestion" size="lg" autocomplete="off" placeholder="Ingrese gestión" autofocus required></b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="danger" size="lg" class="mt-3">Guardar</b-button>
                    <b-button type="reset" size="lg" class="ml-3 mt-3">Cancelar</b-button>
                </b-form>
            </b-card-text>
            <b-alert :show="mostrarAlerta===true" variant="danger" dismissible class="mt-5">{{mensaje}}</b-alert>
        </b-card>
        <div v-else>
            <b-row class="border-bottom" style="background-color: rgba(255,225,0,0.1);">
                <b-col cols="3" class="pt-3">
                    <b-breadcrumb :items="migas"></b-breadcrumb>
                </b-col>
                <b-col cols="9" class="border-left text-left pt-3">
                    <b-button id="btn_creacion" variant="link" @click="crear=!crear">
                        <b-icon icon="folder-plus" font-scale="2.5" variant="info"></b-icon>
                    </b-button>
                    <b-tooltip target="btn_creacion">Crear gestión</b-tooltip>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1" class="mt-3 mb-3" v-for="(carpeta, index) of carpetas" :key="index">
                    <router-link :to="{name: 'colegios', params: {gestion: carpeta.gestion}}">
                    <b-button variant="link">
                        <b-icon icon="folder-fill" font-scale="4" variant="info"></b-icon>
                    </b-button>
                    </router-link>
                    <p><strong>{{carpeta.gestion}}</strong></p>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex'
export default {
    data() {
        return {
            crear: false,
            gestion: '',
            mostrarAlerta: false,
            mensaje: '',
        }
    },
    created() {
        this.agregarMiga({
            text: 'Mis Docs',
            to: {name: 'docs'}
        }),
        this.obtenerCarpetas()
    },
    beforeRouteUpdate(to, from, next) {
      //console.log('DOCS navegado de ${from} a: ${to}')
      next()
    },
    watch: {
        $route(to, from) {
            console.log('WATCH de: ${from} a: ${to}')
        }
    },
    computed: {
        ...mapState(['migas','carpetas']),
        validarGestion() {
            let len = this.gestion.length
            if (len === 0) return null
            if (len === 4) {
                const existe = (item) => item.gestion === this.gestion
                return this.validarNumero(this.gestion) && !this.carpetas.some(existe) ? true: false
            }
            return false
        },
        gestionNoValido() {
            let len = this.gestion.length
            if (len === 4) return 'Ya existe!!'
            else return 'Ingrese numero de 4 digitos, que empiece con 1 o 2'
        }
    },
    methods: {
        ...mapMutations(['agregarMiga','agregarCarpeta']),
        validarNumero(valor) {
            return /^[1-2]\d{3}$/.test(valor)
        },
        guardar() {
            //console.log('Validar gestion:', this.validarGestion)
            if (this.validarGestion) {
                const carpeta = {gestion: this.gestion, id: this.gestion}
                this.axios.post('/carpetas', {nombre: this.gestion})
                    .then(res => {
                        carpeta._id = res.data._id
                        this.agregarCarpeta(carpeta)
                        this.gestion = ''
                        this.crear = false
                    })
                    .catch(e => {
                        //console.log(e)
                        this.mensaje = 'Ha ocurrido un error!'+ e
                        this.mostrarAlerta = true
                    })
            }
        },
        cancelar() {
            this.gestion = ''
            this.crear = false
        },
        obtenerCarpetas() {
            this.carpetas.splice(0)
            this.axios.get('/carpetas')
                .then(res => {
                    //console.log(res)
                    res.data.forEach(elem => {
                        this.carpetas.push({gestion: elem.nombre, id: elem.nombre, _id: elem._id})
                    })
                })
                .catch(e => {
                    console.log(e)
                })
        }
    }
}
</script>